import { useState, useRef, useEffect } from "react";
import Logo from "../assets/images/logo.png";

const T = {
  navy: "#0D0E1C",
  border: "rgba(255,255,255,0.07)",
  purple: "#5856E9",
  violet: "#8B89FF",
  gold: "#C9A84C",
  goldLt: "#F0D078",
  goldDim: "rgba(201,168,76,0.14)",
  white: "#FFFFFF",
  offwhite: "#E8E6F2",
  muted: "#8A8BA8",
  faint: "#4A4B6A",
  success: "#3DD68C",
  error: "#FF6B6B",
};

const individualModules = [
  { id: "m1", part_name: "HTML", price: 20000 },
  { id: "m2", part_name: "CSS", price: 20000 },
  { id: "m3", part_name: "Bootstrap", price: 20000 },
  { id: "m4", part_name: "SCSS", price: 20000 },
  { id: "m5", part_name: "Material UI", price: 20000 },

  { id: "m6", part_name: "ReactJS", price: 50000 },
  { id: "m7", part_name: "NextJS", price: 50000 },
  { id: "m8", part_name: "React Native", price: 60000 },
  { id: "m9", part_name: "Flutter", price: 60000 },

  { id: "m10", part_name: "Apple Online Services", price: 40000 },
  { id: "m11", part_name: "Android Online Services", price: 40000 },

  { id: "m12", part_name: "PHP", price: 40000 },
  { id: "m13", part_name: "Javascript Essentials", price: 40000 },
  { id: "m14", part_name: "Python", price: 40000 },
  { id: "m15", part_name: "NodeJS", price: 40000 },
  { id: "m16", part_name: "Express JS", price: 40000 },

  { id: "m17", part_name: "Prompts", price: 25000 },
  { id: "m18", part_name: "ML Basics", price: 25000 },
  { id: "m19", part_name: "AI Basics", price: 25000 },
  { id: "m20", part_name: "Deploying ML Models", price: 25000 },

  { id: "m21", part_name: "Microsoft SQL", price: 20000 },
  { id: "m22", part_name: "MySQL", price: 20000 },
  { id: "m23", part_name: "SQL", price: 20000 },
  { id: "m24", part_name: "MongoDB", price: 20000 },

  { id: "m25", part_name: "Git & Github", price: 20000 },

  { id: "m26", part_name: "Python Basics", price: 30000 },
  { id: "m27", part_name: "Data Analysis (Pandas / NumPy)", price: 30000 },
  { id: "m28", part_name: "Data Visualization", price: 20000 },
  { id: "m29", part_name: "Regression & Classification", price: 40000 },
  { id: "m30", part_name: "Deep Learning (TensorFlow / Keras)", price: 50000 },
  { id: "m31", part_name: "Natural Language Processing", price: 25000 },
];

const styles = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=DM+Sans:wght@300;400;500;600&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html, body { height: 100%; }

body {
  font-family: 'DM Sans', sans-serif;
  min-height: 100vh;
  overflow-x: hidden;
  background: ${T.navy};
  position: relative;
}

body::before {
  content: '';
  position: fixed; inset: 0;
  background:
    radial-gradient(ellipse 60% 50% at 15% 10%, rgba(88,86,233,0.13) 0%, transparent 55%),
    radial-gradient(ellipse 50% 40% at 85% 85%, rgba(201,168,76,0.07) 0%, transparent 50%);
  pointer-events: none; z-index: 0;
}
body::after {
  content: '';
  position: fixed; inset: 0;
  background-image:
    linear-gradient(rgba(255,255,255,0.016) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.016) 1px, transparent 1px);
  background-size: 44px 44px;
  pointer-events: none; z-index: 0;
}

.page-root{
width:100%;
max-width:1400px;
margin:0 auto;
padding:20px;
min-height:100vh;
display:flex;
flex-direction:column;
position:relative;
z-index:1;
}

/* ── HEADER ── */
.brand-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
  padding: 0 2px;
  animation: fadeD 0.6s cubic-bezier(.22,.61,.36,1) both;
}
.brand-logo-img {
  height: 80px;
  filter: drop-shadow(0 0 10px rgba(88,86,233,0.4));
  flex-shrink: 0;
}
.brand-text-col { display: flex; flex-direction: column; gap: 1px; }
.brand-name {
  font-family: 'Cormorant Garamond', serif;
  font-size: 24px; font-weight: 600;
  color: ${T.white}; letter-spacing: 0.05em; line-height: 1;
}
.brand-tagline {
  font-size: 12px; color: ${T.gold};
  text-transform: uppercase; letter-spacing: 0.2em; font-weight: 500;
}
.header-divider { flex: 1; height: 1px; background: rgba(255,255,255,0.06); }
.event-col { text-align: right; }
.event-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 24px; font-weight: 600;
  color: ${T.offwhite}; line-height: 1.4; letter-spacing: 0.01em;
}
.event-year {
  font-size: 12px; color: ${T.muted};
  letter-spacing: 0.15em; text-transform: uppercase; margin-top: 2px;
}

/* ── STEPS BAR ── */
.steps-bar{
display:flex;
justify-content:center;
align-items:center;
gap:8px;
margin-bottom:18px;
flex-wrap:wrap;
}

.step-block{
display:flex;
align-items:center;
position:relative;
}

/* circle */

.step-circle{
width:32px;
height:32px;
border-radius:50%;
display:flex;
align-items:center;
justify-content:center;

border:1.5px solid #4A4B6A;
background:transparent;

font-family:'Cormorant Garamond',serif;
font-size:13px;
font-weight:600;
color:#4A4B6A;

transition:.3s;
}

/* active */

.step-circle.active{
border-color:#C9A84C;
background:rgba(201,168,76,0.15);
color:#F0D078;
box-shadow:0 0 12px rgba(201,168,76,0.25);
}

/* completed */

.step-circle.done{
border-color:#5856E9;
background:rgba(88,86,233,0.15);
color:#8B89FF;
}

/* label */

.step-label{
font-size:9px;
letter-spacing:.12em;
text-transform:uppercase;
color:#4A4B6A;
margin-left:6px;
margin-right:10px;
white-space:nowrap;
}

.step-label.active{
color:#F0D078;
}

.step-label.done{
color:#8B89FF;
}

/* connector */

.step-conn{
width:30px;
height:1px;
background:#4A4B6A;
margin-right:6px;
margin-left:6px;
opacity:.35;
}

.step-conn.done{
background:#5856E9;
opacity:1;
}

/* ── CARD ── */
.card {
  background: rgba(22,23,38,0.92);
  backdrop-filter: blur(20px); -webkit-backdrop-filter: blur(20px);
  border: 1px solid ${T.border};
  border-radius: 20px;
  padding: 1.4rem 1.6rem 1.5rem;
  box-shadow: 0 20px 60px rgba(0,0,0,0.5), 0 1px 0 rgba(255,255,255,0.05) inset;
  animation: riseUp 0.45s cubic-bezier(.22,.61,.36,1) both;
  position: relative; overflow: hidden;
}
.card::before {
  content: '';
  position: absolute; top: 0; left: 18%; right: 18%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,168,76,0.38), transparent);
}

@keyframes riseUp {
  from { opacity: 0; transform: translateY(18px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes fadeD {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(20px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes popIn {
  from { transform: scale(0) rotate(-15deg); opacity: 0; }
  to   { transform: scale(1) rotate(0); opacity: 1; }
}
@keyframes shimmer {
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
}
@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-6px); }
}
@keyframes pulse-ring {
  0% { box-shadow: 0 0 0 0 rgba(88,86,233,0.3); }
  70% { box-shadow: 0 0 0 10px rgba(88,86,233,0); }
  100% { box-shadow: 0 0 0 0 rgba(88,86,233,0); }
}
@keyframes slideIn {
  from { opacity: 0; transform: translateX(-12px); }
  to   { opacity: 1; transform: translateX(0); }
}

/* ── FORM FIELDS ── */
.card-eyebrow {
  font-size: 8.5px; letter-spacing: 0.18em; color: ${T.gold};
  text-transform: uppercase; font-weight: 500; margin-bottom: 3px;
  display: flex; align-items: center; gap: 7px;
}
.card-eyebrow::before { content: ''; width: 16px; height: 1px; background: ${T.gold}; opacity: 0.55; }
.card-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 20px; font-weight: 600; color: ${T.white};
  margin-bottom: 2px; letter-spacing: -0.01em;
}
.card-sub {
  font-size: 11.5px; color: ${T.muted}; margin-bottom: 1rem;
  font-weight: 300; line-height: 1.4;
}
.field-row { display: flex; gap: 10px; margin-bottom: 0.7rem; }
.field { display: flex; flex-direction: column; gap: 4px; flex: 1; }
.field-full { margin-bottom: 0.7rem; }
.flbl {
  font-size: 8.5px; font-weight: 600; color: ${T.muted};
  letter-spacing: 0.15em; text-transform: uppercase; display: block; margin-bottom: 2px;
}
.iwrap { position: relative; }
.iico {
  position: absolute; left: 11px; top: 50%; transform: translateY(-50%);
  width: 13px; height: 13px; color: ${T.faint};
  pointer-events: none; display: flex; transition: color 0.2s;
}
.iwrap:focus-within .iico { color: ${T.violet}; }
.fi {
  width: 100%; height: 38px; padding: 0 10px 0 32px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08); border-radius: 9px;
  font-family: 'DM Sans', sans-serif; font-size: 12.5px; color: ${T.white};
  outline: none;
  transition: border-color 0.22s, background 0.22s, box-shadow 0.22s;
}
.fi::placeholder { color: ${T.faint}; }
.fi:hover { border-color: rgba(255,255,255,0.13); background: rgba(255,255,255,0.05); }
.fi:focus {
  border-color: rgba(139,137,255,0.5); background: rgba(88,86,233,0.08);
  box-shadow: 0 0 0 3px rgba(88,86,233,0.1);
}
.fi.err { border-color: rgba(255,107,107,0.5); box-shadow: 0 0 0 3px rgba(255,107,107,0.08); }
.emsg { font-size: 10px; color: ${T.error}; margin-top: 2px; font-weight: 400; }
.sec-div {
  display: flex; align-items: center; gap: 10px; margin: 0.7rem 0 0.6rem;
}
.sec-div::before, .sec-div::after { content: ''; flex: 1; height: 1px; background: rgba(255,255,255,0.06); }
.sec-div span { font-size: 8.5px; letter-spacing: 0.15em; text-transform: uppercase; color: ${T.faint}; white-space: nowrap; }
.cb-row {
  display: flex; align-items: center; gap: 9px;
  margin-bottom: 0.85rem; cursor: pointer;
}
.cb-row input { width: 15px; height: 15px; accent-color: ${T.purple}; cursor: pointer; flex-shrink: 0; }
.cb-row span { font-size: 11.5px; color: ${T.muted}; font-weight: 300; }
.cb-row a { color: ${T.violet}; font-weight: 500; text-decoration: none; }

/* ── BUTTONS ── */
.btn-pri {
  width: 100%; height: 44px;
  background: linear-gradient(135deg, #5856E9 0%, #7B56E9 100%);
  color: white; border: none; border-radius: 11px;
  font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 600;
  letter-spacing: 0.04em; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  transition: transform 0.16s, box-shadow 0.16s, filter 0.16s;
  box-shadow: 0 4px 18px rgba(88,86,233,0.35), 0 1px 0 rgba(255,255,255,0.1) inset;
  position: relative; overflow: hidden;
}
.btn-pri::before {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, transparent 55%);
}
.btn-pri:hover { transform: translateY(-2px); box-shadow: 0 8px 28px rgba(88,86,233,0.48); filter: brightness(1.08); }
.btn-pri:active { transform: scale(0.99); }
.btn-ghost {
  width: 100%; height: 44px;
  background: transparent; color: ${T.offwhite};
  border: 1px solid rgba(255,255,255,0.12); border-radius: 11px;
  font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 500; cursor: pointer;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  transition: border-color 0.2s, background 0.2s, color 0.2s;
}
.btn-ghost:hover { border-color: rgba(201,168,76,0.4); background: rgba(201,168,76,0.05); color: ${T.goldLt}; }

/* ── PAYMENT ── */
.pay-layout { display: flex; gap: 14px; margin-bottom: 0.9rem; }
.qr-side {
  display: flex; flex-direction: column; align-items: center; gap: 8px;
  flex-shrink: 0; width: 100%;
}
.qr-box {
  width: 100%;
max-height:420px;
height:auto; border-radius: 12px; padding: 8px;
  display: flex; align-items: center; justify-content: center;
}
.qr-box img { width: 100%; height: 100%; object-fit: contain; border-radius: 4px; }
.qr-ph { width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px; border: 1.5px dashed #DDD; border-radius: 6px; }
.qr-ph span { font-size: 9px; color: #BBB; }
.amt-badge {
  display: inline-flex; align-items: center; gap: 5px;
  background: ${T.goldDim}; border: 1px solid rgba(201,168,76,0.28);
  border-radius: 50px; padding: 4px 10px;
  font-size: 11px; font-weight: 600; color: ${T.goldLt};
}
  @media (max-width:700px){

.field-row{
flex-direction:column;
}

.main-layout{
flex-direction:column;
gap:20px;
}

.form-side{
min-width:unset;
width:100%;
}

.step-actions{
flex-direction:column;
}

}
@media (max-width:600px){

.steps-bar{
gap:6px;
}

.step-label{
display:none;
}

.step-circle{
width:28px;
height:28px;
font-size:12px;
}

}
@media (max-width:480px){

.btn-pri,
.btn-back,
.btn-ghost{
height:48px;
font-size:14px;
}

}
.qr-desc { font-size: 10.5px; color: ${T.muted}; text-align: center; line-height: 1.5; max-width: 120px; font-weight: 300; }
.upload-side { flex: 1; display: flex; flex-direction: column; gap: 8px; }
.upload-label { font-size: 8.5px; font-weight: 600; color: ${T.muted}; letter-spacing: 0.15em; text-transform: uppercase; }
.up-area {
  flex: 1; border: 1px dashed rgba(255,255,255,0.1); border-radius: 12px;
  display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px;
  cursor: pointer; transition: border-color 0.22s, background 0.22s;
  background: rgba(255,255,255,0.02); position: relative; padding: 14px 10px;
}
.up-area:hover, .up-area.has-f { border-color: rgba(139,137,255,0.4); background: rgba(88,86,233,0.06); }
.up-area input { position: absolute; inset: 0; opacity: 0; cursor: pointer; width: 100%; height: 100%; }
.up-ico { width: 34px; height: 34px; background: rgba(88,86,233,0.14); border: 1px solid rgba(88,86,233,0.24); border-radius: 9px; display: flex; align-items: center; justify-content: center; }
.up-txt { font-size: 11px; color: ${T.muted}; font-weight: 300; text-align: center; }
.up-txt strong { color: ${T.violet}; font-weight: 500; }
.up-hint { font-size: 9.5px; color: ${T.faint}; }
.f-name { font-size: 11px; color: ${T.violet}; font-weight: 500; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }

/* ── SUCCESS ── */
.succ-layout { display: flex; flex-direction: column; align-items: center; }
.succ-ico {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(61,214,140,0.09); border: 1.5px solid rgba(61,214,140,0.3);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 10px; animation: popIn 0.5s cubic-bezier(.22,.61,.36,1.4) both;
  box-shadow: 0 0 24px rgba(61,214,140,0.12);
}
.succ-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 22px; font-weight: 600; color: ${T.white};
  text-align: center; margin-bottom: 6px;
}
.succ-msg { font-size: 12px; color: ${T.muted}; text-align: center; line-height: 1.65; margin-bottom: 1rem; font-weight: 300; }
.succ-msg strong { color: ${T.offwhite}; font-weight: 500; }
.info-pill {
  display: flex; align-items: flex-start; gap: 9px;
  background: rgba(88,86,233,0.09); border: 1px solid rgba(88,86,233,0.18);
  border-radius: 10px; padding: 10px 12px; margin-bottom: 0.9rem; width: 100%;
}
.info-pill span { font-size: 11px; color: ${T.violet}; font-weight: 400; line-height: 1.55; }
.sum-box {
  background: rgba(255,255,255,0.025); border: 1px solid rgba(255,255,255,0.055);
  border-radius: 12px; padding: 12px 14px; margin-bottom: 0.9rem; width: 100%; text-align: left;
}
.sum-h { font-size: 8px; font-weight: 600; color: ${T.faint}; text-transform: uppercase; letter-spacing: 0.18em; margin-bottom: 8px; }
.sum-row { display: flex; justify-content: space-between; font-size: 11.5px; padding: 5px 0; border-bottom: 1px solid rgba(255,255,255,0.04); }
.sum-row:last-child { border-bottom: none; }
.sk { color: ${T.faint}; font-weight: 300; }
.sv { color: ${T.offwhite}; font-weight: 500; }

/* ── MAIN LAYOUT ── */
.main-layout { display: flex; gap: 40px; align-items: stretch; }
.form-side { flex: 1; min-width: 380px; }

/* ── STEP ACTIONS ── */
.step-actions {
  display: flex; justify-content: center; align-items: center;
  gap: 10px; margin-top: 16px;
}
.btn-back {
  height: 44px; padding: 0 16px; border-radius: 11px;
  border: 1px solid rgba(255,255,255,0.12);
  background: transparent; color: #E8E6F2;
  font-size: 13px; cursor: pointer;
  display: flex; align-items: center; gap: 6px; transition: .2s;
}
.btn-back:hover { border-color: #8B89FF; background: rgba(88,86,233,0.08); color: #8B89FF; }

/* ── PROGRAM STEP ── */
.program-layout { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-top: 10px; }
@media (max-width:900px){
.program-layout{
grid-template-columns:1fr;
}
}
.program-box { border: 1px solid rgba(255,255,255,0.08); border-radius: 12px; padding: 14px; background: rgba(255,255,255,0.02); overflow-y: auto; }
.program-box h3 { font-size: 12px; color: #8A8BA8; letter-spacing: 0.1em; text-transform: uppercase; margin-bottom: 10px; }
.course-btn {
  width: 100%; display: flex; justify-content: space-between; padding: 10px 12px;
  border: 1px solid rgba(255,255,255,0.06); border-radius: 8px;
  background: rgba(255,255,255,0.03); color: white; margin-bottom: 6px;
  cursor: pointer; font-size: 12px; transition: all .2s;
}
.course-btn:hover { background: rgba(88,86,233,0.08); border-color: rgba(88,86,233,0.3); }
.course-btn.active { background: rgba(88,86,233,0.12); border-color: #5856E9; }
.module-row { display: flex; justify-content: space-between; align-items: center; border: 1px solid rgba(255,255,255,0.06); border-radius: 8px; padding: 8px 10px; margin-bottom: 6px; }
.module-row input { margin-right: 6px; }
.total-box { margin-top: 14px; border-top: 1px solid rgba(255,255,255,0.08); padding-top: 10px; display: flex; justify-content: space-between; font-weight: 600; font-size: 14px; color: white; }
.program-next { margin-top: 14px; }

/* ════════════════════════════════════════
   STEP 1 — HERO  (redesigned)
════════════════════════════════════════ */

.hero-wrap {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.07);
  background: rgba(14,15,28,0.95);
  backdrop-filter: blur(24px);
  animation: riseUp 0.5s cubic-bezier(.22,.61,.36,1) both;
}

/* decorative blobs */
.hero-blob {
  position: absolute; border-radius: 50%; pointer-events: none; filter: blur(60px);
}
.hero-blob-1 {
  width: 340px; height: 340px; top: -100px; right: -60px;
  background: radial-gradient(circle, rgba(88,86,233,0.28) 0%, transparent 70%);
}
.hero-blob-2 {
  width: 260px; height: 260px; bottom: -80px; left: -40px;
  background: radial-gradient(circle, rgba(201,168,76,0.18) 0%, transparent 70%);
}

.hero-inner {
  position: relative; z-index: 2;
  padding: 36px 40px 32px;
}

/* top badge row */
.hero-badge-row {
  display: flex; align-items: center; gap: 10px;
  margin-bottom: 28px;
  animation: fadeUp 0.5s 0.1s both;
}
.hero-badge {
  display: inline-flex; align-items: center; gap: 7px;
  background: rgba(88,86,233,0.15);
  border: 1px solid rgba(88,86,233,0.4);
  padding: 6px 14px; border-radius: 30px;
  font-size: 10.5px; letter-spacing: 0.1em; color: #8B89FF;
  font-weight: 500;
}
.hero-badge-dot {
  width: 6px; height: 6px; border-radius: 50%;
  background: #8B89FF; animation: pulse-ring 1.6s infinite;
}
.hero-year-tag {
  display: inline-flex; align-items: center; gap: 5px;
  background: ${T.goldDim}; border: 1px solid rgba(201,168,76,0.3);
  padding: 5px 12px; border-radius: 30px;
  font-size: 10.5px; color: ${T.goldLt}; font-weight: 600; letter-spacing: 0.08em;
}

/* main title */
.hero-title-block {
  margin-bottom: 20px;
  animation: fadeUp 0.55s 0.18s both;
}
.hero-title-lg {
  font-family: 'Cormorant Garamond', serif;
  font-size:clamp(32px,6vw,56px); font-weight: 700; line-height: 1.0;
  color: white; letter-spacing: -0.02em;
}
.hero-title-lg em {
  font-style: italic; color: ${T.goldLt};
}
.hero-subtitle {
  font-size:clamp(13px,2.5vw,15px); color: rgba(232,230,242,0.75);
  margin-top: 10px; font-weight: 300; letter-spacing: 0.01em;
  max-width: 480px; line-height: 1.55;
}

/* two column grid */
.hero-content-grid{
display:grid;
grid-template-columns:1fr 380px;
gap:32px;
}

@media (max-width: 1024px){
.hero-content-grid{
grid-template-columns:1fr;
}
}

/* left col */
.hero-left { display: flex; flex-direction: column; gap: 20px; }

/* stat row */
.hero-stats {
  display: flex; gap: 12px;
  animation: fadeUp 0.55s 0.26s both;
}
.hero-stat {
  flex: 1; background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px; padding: 14px 16px;
  transition: border-color 0.2s, background 0.2s;
}
.hero-stat:hover { border-color: rgba(88,86,233,0.35); background: rgba(88,86,233,0.07); }
.hero-stat-val {
  font-family: 'Cormorant Garamond', serif;
  font-size: 30px; font-weight: 700; color: white; line-height: 1;
}
.hero-stat-val span { color: ${T.goldLt}; }
.hero-stat-lbl { font-size: 10px; color: ${T.muted}; margin-top: 4px; text-transform: uppercase; letter-spacing: 0.1em; }

/* CTA row */
.hero-cta-row {
  display: flex; align-items: center; gap: 16px;
  animation: fadeUp 0.55s 0.34s both;
}
.hero-cta-btn {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 28px; border-radius: 13px; border: none; cursor: pointer;
  background: linear-gradient(135deg, #5856E9, #7B56E9);
  color: white; font-family: 'DM Sans', sans-serif;
  font-size: 14px; font-weight: 600; letter-spacing: 0.03em;
  box-shadow: 0 6px 24px rgba(88,86,233,0.4);
  transition: transform 0.18s, box-shadow 0.18s, filter 0.18s;
  position: relative; overflow: hidden;
}
.hero-cta-btn::before {
  content: ''; position: absolute; inset: 0;
  background: linear-gradient(135deg, rgba(255,255,255,0.12) 0%, transparent 60%);
}
.hero-cta-btn:hover { transform: translateY(-2px); box-shadow: 0 10px 32px rgba(88,86,233,0.55); filter: brightness(1.08); }
.hero-fee-note {
  font-size: 12px; color: ${T.muted};
}
.hero-fee-note strong { color: ${T.offwhite}; }

/* right col — scholarship card */
.sch-card {
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07);
  border-radius: 18px; padding: 22px;
  animation: fadeUp 0.55s 0.22s both;
}
.sch-card-head {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 16px;
}
.sch-card-title {
  font-family: 'Cormorant Garamond', serif;
  font-size: 18px; font-weight: 600; color: white;
}
.sch-trophy { font-size: 22px; animation: float 3s ease-in-out infinite; }

.sch-tiers { display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px; }
.sch-tier-row {
  display: flex; align-items: center; gap: 12px;
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06);
  border-radius: 10px; padding: 10px 14px;
  transition: border-color 0.2s, background 0.2s;
}
.sch-tier-row:hover { border-color: rgba(201,168,76,0.3); background: rgba(201,168,76,0.04); }
.sch-pct {
  font-family: 'Cormorant Garamond', serif;
  font-size: 22px; font-weight: 700; min-width: 52px;
}
.sch-pct.gold  { color: #F0D078; }
.sch-pct.silver{ color: #C0C8D8; }
.sch-pct.bronze{ color: #E0A060; }
.sch-pct.extra { color: #8B89FF; }
.sch-tier-info { flex: 1; }
.sch-tier-label { font-size: 12px; color: ${T.offwhite}; font-weight: 500; }
.sch-tier-count { font-size: 10px; color: ${T.muted}; margin-top: 1px; }
.sch-tier-badge {
  font-size: 9px; padding: 3px 8px; border-radius: 20px; font-weight: 600;
  letter-spacing: 0.05em;
}
.sch-tier-badge.gold   { background: rgba(240,208,120,0.15); color: #F0D078; border: 1px solid rgba(240,208,120,0.3); }
.sch-tier-badge.silver { background: rgba(192,200,216,0.15); color: #C0C8D8; border: 1px solid rgba(192,200,216,0.3); }
.sch-tier-badge.bronze { background: rgba(224,160,96,0.15);  color: #E0A060; border: 1px solid rgba(224,160,96,0.3); }
.sch-tier-badge.extra  { background: rgba(139,137,255,0.15); color: #8B89FF; border: 1px solid rgba(139,137,255,0.3); }

.sch-divider { height: 1px; background: rgba(255,255,255,0.06); margin: 4px 0 12px; }

.sch-tracks { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.sch-track {
  display: flex; align-items: center; gap: 8px;
  background: rgba(88,86,233,0.08); border: 1px solid rgba(88,86,233,0.2);
  border-radius: 9px; padding: 9px 11px;
  font-size: 11px; color: ${T.offwhite};
}
.sch-track-ico { font-size: 15px; }

/* ════════════════════════════════════════
   STEP 2 — ABOUT  (redesigned)
════════════════════════════════════════ */

.about-wrap {
  border-radius: 20px; overflow: hidden;
  border: 1px solid rgba(255,255,255,0.07);
  background: rgba(14,15,28,0.95);
  backdrop-filter: blur(24px);
  animation: riseUp 0.45s cubic-bezier(.22,.61,.36,1) both;
  position: relative;
}
.about-wrap::before {
  content: '';
  position: absolute; top: 0; left: 18%; right: 18%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,168,76,0.38), transparent);
}
.about-inner { padding: 32px 36px; position: relative; z-index: 1; }

.about-kicker {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 9.5px; letter-spacing: 0.2em; text-transform: uppercase;
  color: ${T.gold}; font-weight: 600; margin-bottom: 8px;
}
.about-kicker::before { content: ''; width: 20px; height: 1px; background: ${T.gold}; }

.about-headline {
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px; font-weight: 700; color: white;
  line-height: 1.1; letter-spacing: -0.01em; margin-bottom: 6px;
}
.about-headline em { font-style: italic; color: ${T.goldLt}; }

.about-lead {
  font-size: 13px; color: rgba(232,230,242,0.65);
  font-weight: 300; line-height: 1.6; margin-bottom: 28px; max-width: 580px;
}

/* three pillars */
.about-pillars {
  display: grid; grid-template-columns: repeat(3,1fr); gap: 12px;
  margin-bottom: 26px;
}
.about-pillar {
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; padding: 18px 16px;
  background: rgba(255,255,255,0.03);
  transition: border-color 0.25s, background 0.25s, transform 0.25s;
  cursor: default; position: relative; overflow: hidden;
}
.about-pillar::after {
  content: ''; position: absolute; inset: 0; opacity: 0;
  background: linear-gradient(135deg, rgba(88,86,233,0.08), transparent);
  transition: opacity 0.25s;
}
.about-pillar:hover { border-color: rgba(88,86,233,0.35); transform: translateY(-3px); }
.about-pillar:hover::after { opacity: 1; }
.pillar-ico {
  width: 40px; height: 40px; border-radius: 11px;
  background: rgba(88,86,233,0.12); border: 1px solid rgba(88,86,233,0.25);
  display: flex; align-items: center; justify-content: center;
  font-size: 18px; margin-bottom: 12px;
}
.pillar-title { font-size: 13px; color: ${T.goldLt}; font-weight: 600; margin-bottom: 5px; }
.pillar-body { font-size: 11px; color: ${T.muted}; line-height: 1.55; }

/* why row */
.about-why {
  background: rgba(88,86,233,0.07); border: 1px solid rgba(88,86,233,0.18);
  border-radius: 14px; padding: 16px 20px;
  display: flex; align-items: center; gap: 20px;
  margin-bottom: 24px;
}
.about-why-text { flex: 1; }
.about-why-label {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.15em;
  color: ${T.violet}; font-weight: 600; margin-bottom: 4px;
}
.about-why-body { font-size: 12px; color: ${T.offwhite}; line-height: 1.5; }
.about-why-body strong { color: white; }
.company-chips { display: flex; gap: 7px; flex-wrap: wrap; }
.company-chip {
  background: rgba(88,86,233,0.12); border: 1px solid rgba(88,86,233,0.28);
  padding: 5px 12px; border-radius: 20px;
  font-size: 10.5px; color: #8B89FF; font-weight: 500;
  letter-spacing: 0.04em;
}

/* eligibility */
.about-elig-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 24px; }
.elig-card {
  border: 1px solid rgba(255,255,255,0.07); border-radius: 14px;
  padding: 18px; background: rgba(255,255,255,0.02);
  transition: border-color 0.22s;
}
.elig-card:hover { border-color: rgba(201,168,76,0.3); }
.elig-head {
  display: flex; align-items: center; gap: 9px;
  margin-bottom: 12px;
}
.elig-head-ico {
  width: 34px; height: 34px; border-radius: 9px;
  background: ${T.goldDim}; border: 1px solid rgba(201,168,76,0.3);
  display: flex; align-items: center; justify-content: center; font-size: 16px;
}
.elig-head-title { font-size: 13px; color: ${T.goldLt}; font-weight: 600; }
.elig-head-sub { font-size: 10px; color: ${T.muted}; }
.elig-list { display: flex; flex-direction: column; gap: 4px; }
.elig-item {
  display: flex; align-items: center; gap: 7px;
  font-size: 11px; color: rgba(232,230,242,0.75);
}
.elig-dot { width: 4px; height: 4px; border-radius: 50%; background: ${T.violet}; flex-shrink: 0; }
.elig-no-code {
  margin-top: 10px; padding: 7px 10px; border-radius: 8px;
  background: rgba(88,86,233,0.1); border: 1px solid rgba(88,86,233,0.25);
  font-size: 10.5px; color: ${T.violet}; font-weight: 500;
  display: flex; align-items: center; gap: 6px;
}

@media (max-width:900px){

.about-pillars{
grid-template-columns:1fr 1fr;
}

.exam-grid{
grid-template-columns:1fr;
}

.career-two-col{
grid-template-columns:1fr;
}

.career-roles-grid{
grid-template-columns:1fr;
}

}

/* ════════════════════════════════════════
   STEP 3 — EXAM  (redesigned)
════════════════════════════════════════ */

.exam-wrap {
  border-radius: 20px; overflow: hidden;
  border: 1px solid rgba(255,255,255,0.07);
  background: rgba(14,15,28,0.95);
  backdrop-filter: blur(24px);
  animation: riseUp 0.45s cubic-bezier(.22,.61,.36,1) both;
  position: relative;
}
.exam-wrap::before {
  content: '';
  position: absolute; top: 0; left: 18%; right: 18%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,168,76,0.38), transparent);
}
.exam-inner { padding: 32px 36px; position: relative; z-index: 1; }

.exam-kicker {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 9.5px; letter-spacing: 0.2em; text-transform: uppercase;
  color: ${T.gold}; font-weight: 600; margin-bottom: 8px;
}
.exam-kicker::before { content: ''; width: 20px; height: 1px; background: ${T.gold}; }

.exam-headline {
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px; font-weight: 700; color: white;
  line-height: 1.1; margin-bottom: 6px; letter-spacing: -0.01em;
}
.exam-headline em { font-style: italic; color: ${T.goldLt}; }
.exam-lead { font-size: 13px; color: rgba(232,230,242,0.6); font-weight: 300; line-height: 1.6; margin-bottom: 26px; }

/* two-col grid */
.exam-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 24px; }

/* left — exam meta */
.exam-meta-col { display: flex; flex-direction: column; gap: 12px; }
.exam-stat-row { display: flex; gap: 10px; }
.exam-stat-box {
  flex: 1; background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 12px; padding: 14px 16px; text-align: center;
}
.exam-stat-icon { font-size: 22px; margin-bottom: 6px; }
.exam-stat-val { font-family: 'Cormorant Garamond', serif; font-size: 24px; font-weight: 700; color: white; }
.exam-stat-lbl { font-size: 10px; color: ${T.muted}; text-transform: uppercase; letter-spacing: 0.1em; margin-top: 2px; }

.exam-sections-box {
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; padding: 16px;
}
.exam-sections-title {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.15em;
  color: ${T.gold}; font-weight: 600; margin-bottom: 12px;
}
.exam-section-item {
  display: flex; align-items: center; gap: 10px;
  padding: 8px 0; border-bottom: 1px solid rgba(255,255,255,0.05);
}
.exam-section-item:last-child { border-bottom: none; }
.exam-section-num {
  width: 22px; height: 22px; border-radius: 6px;
  background: rgba(88,86,233,0.15); border: 1px solid rgba(88,86,233,0.3);
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 600; color: ${T.violet}; flex-shrink: 0;
}
.exam-section-name { font-size: 12px; color: ${T.offwhite}; font-weight: 400; }

/* right — skills grid */
.exam-skills-col { display: flex; flex-direction: column; gap: 10px; }
.exam-skills-title {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.15em;
  color: ${T.gold}; font-weight: 600;
}
.exam-skills-grid { display: flex; flex-direction: column; gap: 8px; }
.skill-row {
  display: flex; align-items: center; gap: 12px;
  background: rgba(88,86,233,0.07); border: 1px solid rgba(88,86,233,0.18);
  border-radius: 11px; padding: 12px 14px;
  transition: border-color 0.2s, background 0.2s;
}
.skill-row:hover { border-color: rgba(88,86,233,0.4); background: rgba(88,86,233,0.12); }
.skill-ico-box {
  width: 36px; height: 36px; border-radius: 9px;
  background: rgba(88,86,233,0.15); border: 1px solid rgba(88,86,233,0.3);
  display: flex; align-items: center; justify-content: center;
  font-size: 17px; flex-shrink: 0;
}
.skill-name { font-size: 12.5px; color: ${T.offwhite}; font-weight: 500; }
.skill-tags { display: flex; gap: 5px; margin-top: 3px; flex-wrap: wrap; }
.skill-tag {
  font-size: 9px; padding: 2px 7px; border-radius: 10px;
  background: rgba(88,86,233,0.15); color: ${T.violet}; font-weight: 500;
}

/* roadmap timeline */
.roadmap-section { margin-bottom: 20px; }
.roadmap-title {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.15em;
  color: ${T.gold}; font-weight: 600; margin-bottom: 14px;
  display: flex; align-items: center; gap: 8px;
}
.roadmap-title::after { content: ''; flex: 1; height: 1px; background: rgba(255,255,255,0.06); }

.roadmap-timeline { display: flex; gap: 0; align-items: flex-start; }
.roadmap-step {
  flex: 1; display: flex; flex-direction: column; align-items: center;
  position: relative;
}
.roadmap-step:not(:last-child)::after {
  content: ''; position: absolute; top: 14px; left: 50%; width: 100%;
  height: 1px; background: linear-gradient(90deg, rgba(88,86,233,0.6), rgba(88,86,233,0.2));
}
.roadmap-node {
  width: 28px; height: 28px; border-radius: 50%;
  background: rgba(88,86,233,0.2); border: 1.5px solid rgba(88,86,233,0.5);
  display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 700; color: ${T.violet};
  margin-bottom: 8px; position: relative; z-index: 1;
  background: #0D0E1C;
}
.roadmap-text {
  font-size: 9.5px; color: ${T.muted}; text-align: center;
  line-height: 1.4; padding: 0 4px;
}
.roadmap-end-note {
  text-align: center; font-size: 12px; color: ${T.violet};
  font-weight: 500; margin-top: 14px;
  background: rgba(88,86,233,0.07); border: 1px solid rgba(88,86,233,0.18);
  border-radius: 10px; padding: 10px;
}


/* ════════════════════════════════════════
   STEP 4 — CAREER  (redesigned)
════════════════════════════════════════ */

.career-wrap {
  border-radius: 20px; overflow: hidden;
  border: 1px solid rgba(255,255,255,0.07);
  background: rgba(14,15,28,0.95);
  backdrop-filter: blur(24px);
  animation: riseUp 0.45s cubic-bezier(.22,.61,.36,1) both;
  position: relative;
}
.career-wrap::before {
  content: '';
  position: absolute; top: 0; left: 18%; right: 18%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,168,76,0.38), transparent);
}
.career-inner { padding: 32px 36px; position: relative; z-index: 1; }

.career-kicker {
  display: inline-flex; align-items: center; gap: 8px;
  font-size: 9.5px; letter-spacing: 0.2em; text-transform: uppercase;
  color: ${T.gold}; font-weight: 600; margin-bottom: 8px;
}
.career-kicker::before { content: ''; width: 20px; height: 1px; background: ${T.gold}; }

.career-headline {
  font-family: 'Cormorant Garamond', serif;
  font-size: 36px; font-weight: 700; color: white;
  line-height: 1.1; margin-bottom: 6px; letter-spacing: -0.01em;
}
.career-headline em { font-style: italic; color: ${T.goldLt}; }
.career-lead { font-size: 13px; color: rgba(232,230,242,0.6); font-weight: 300; line-height: 1.6; margin-bottom: 24px; }

/* two-col */
.career-two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 22px; }

/* career roles */
.career-roles-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
.career-role-card {
  border: 1px solid rgba(255,255,255,0.07); border-radius: 12px;
  padding: 14px; background: rgba(255,255,255,0.03);
  display: flex; align-items: flex-start; gap: 10px;
  transition: border-color 0.22s, background 0.22s, transform 0.22s;
}
.career-role-card:hover { border-color: rgba(88,86,233,0.35); background: rgba(88,86,233,0.07); transform: translateY(-2px); }
.role-ico {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: rgba(88,86,233,0.15); border: 1px solid rgba(88,86,233,0.3);
  display: flex; align-items: center; justify-content: center; font-size: 16px;
}
.role-name { font-size: 11.5px; color: ${T.offwhite}; font-weight: 500; line-height: 1.3; margin-top: 3px; }

/* certs */
.career-certs-col {}
.career-certs-title {
  font-size: 10px; text-transform: uppercase; letter-spacing: 0.15em;
  color: ${T.gold}; font-weight: 600; margin-bottom: 12px;
}
.cert-item {
  display: flex; align-items: center; gap: 12px;
  border: 1px solid rgba(255,255,255,0.07); border-radius: 11px;
  padding: 12px 14px; background: rgba(255,255,255,0.02);
  margin-bottom: 8px;
  transition: border-color 0.22s;
}
.cert-item:hover { border-color: rgba(201,168,76,0.3); }
.cert-ico {
  width: 32px; height: 32px; border-radius: 9px; flex-shrink: 0;
  background: ${T.goldDim}; border: 1px solid rgba(201,168,76,0.3);
  display: flex; align-items: center; justify-content: center; font-size: 15px;
}
.cert-name { font-size: 12px; color: ${T.offwhite}; font-weight: 500; }
.cert-detail { font-size: 10px; color: ${T.muted}; margin-top: 1px; }

/* opportunity banner */
.opp-banner {
  background: rgba(88,86,233,0.09); border: 1px solid rgba(88,86,233,0.22);
  border-radius: 14px; padding: 14px 18px;
  display: flex; align-items: center; gap: 14px;
  margin-bottom: 16px;
}
.opp-star { font-size: 26px; animation: float 3s ease-in-out infinite; }
.opp-text { flex: 1; }
.opp-title { font-size: 13px; color: white; font-weight: 600; margin-bottom: 2px; }
.opp-body { font-size: 11px; color: ${T.muted}; line-height: 1.5; }

/* limited + cta row */
.career-bottom-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 20px; }
.limited-panel {
  background: rgba(201,168,76,0.07); border: 1px solid rgba(201,168,76,0.3);
  border-radius: 14px; padding: 16px;
}
.limited-panel h4 { color: ${T.goldLt}; font-size: 13px; font-weight: 600; margin-bottom: 8px; }
.limited-panel p { font-size: 12px; color: ${T.offwhite}; line-height: 1.6; }
.limited-panel strong { color: ${T.goldLt}; }

.contact-panel {
  background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.07);
  border-radius: 14px; padding: 16px;
}
.contact-panel h4 { color: ${T.offwhite}; font-size: 13px; font-weight: 600; margin-bottom: 10px; }
.contact-row {
  display: flex; align-items: center; gap: 8px;
  font-size: 11px; color: ${T.muted}; margin-bottom: 6px;
}
.contact-row strong { color: ${T.offwhite}; font-weight: 500; }
.contact-icon { font-size: 13px; }

@media (max-width: 480px) {
  .brand-header { flex-wrap: wrap; gap: 8px; }
  .header-divider { display: none; }
  .event-col { text-align: left; }
  .hero-content-grid { grid-template-columns: 1fr; }
  .hero-stats { flex-direction: column; }
  .about-pillars { grid-template-columns: 1fr; }
  .about-elig-row { grid-template-columns: 1fr; }
  .exam-grid { grid-template-columns: 1fr; }
  .career-two-col { grid-template-columns: 1fr; }
  .career-bottom-row { grid-template-columns: 1fr; }
}

.module-row{
display: flex;
justify-content: space-between;
align-items: center;
}
  .module-row input:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.module-row input:disabled + span {
  opacity: 0.5;
}
  .module-label{
  display: flex;
  justify-content: center;
  align-items: center;
  }

  .module-card{
border:1px solid rgba(255,255,255,0.06);
border-radius:10px;
padding:10px 12px;
background:rgba(255,255,255,0.02);
margin-bottom:8px;
transition:.2s;
}

.module-card:hover{
border-color:#5856E9;
background:rgba(88,86,233,0.08);
}

.module-label{
display:flex;
align-items:center;
gap:10px;
cursor:pointer;
}

.module-info{
display:flex;
justify-content:space-between;
width:100%;
align-items:center;
}

.module-title{
font-size:12px;
color:white;
}

.module-price{
font-size:11px;
color:#8B89FF;
font-weight:600;
}

.module-label input{
accent-color:#5856E9;
}

.module-label input:disabled{
opacity:0.35;
cursor:not-allowed;
}
.module-checkbox{
  display:none;
}

.checkbox-ui{
  width:18px;
  height:18px;
  border-radius:5px;
  border:2px solid rgba(255,255,255,0.25);
  display:flex;
  align-items:center;
  justify-content:center;
  transition:.25s;
  flex-shrink:0;
}

/* checked state */

.module-checkbox:checked + .checkbox-ui{
  border-color:#5856E9;
  background:linear-gradient(135deg,#5856E9,#7B56E9);
  box-shadow:0 0 10px rgba(88,86,233,0.5);
}

.module-checkbox:checked + .checkbox-ui::after{
  content:"✓";
  color:white;
  font-size:12px;
  font-weight:700;
}

/* disabled */

.module-checkbox:disabled + .checkbox-ui{
  opacity:.35;
  cursor:not-allowed;
}

/* hover */

.module-label:hover .checkbox-ui{
  border-color:#8B89FF;
}
`;

const Ico = {
  user: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="13"
      height="13"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  mail: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="13"
      height="13"
    >
      <rect x="2" y="4" width="20" height="16" rx="2" />
      <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
    </svg>
  ),
  phone: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="13"
      height="13"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.15 12 19.79 19.79 0 0 1 1.08 3.41 2 2 0 0 1 3 1.15h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.09 8.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 21 16z" />
    </svg>
  ),
  check: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="13"
      height="13"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  checkG: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#3DD68C"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="30"
      height="30"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  arrow: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="14"
      height="14"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  ),
  upload: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#8B89FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="17"
      height="17"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line x1="12" y1="3" x2="12" y2="15" />
    </svg>
  ),
  qr: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#AAAACC"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="40"
      height="40"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <path d="M14 14h.01M18 14h.01M14 18h.01M18 18h.01M14 21h.01M21 14h.01M21 21h.01M21 18h.01" />
    </svg>
  ),
  info: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="#8B89FF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="15"
      height="15"
      style={{ flexShrink: 0, marginTop: "1px" }}
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  home: (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="14"
      height="14"
    >
      <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),
};

export default function OlympiadRegistration() {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    terms: false,
  });
  const [errors, setErrors] = useState({});
  const [screenshot, setScreenshot] = useState(null);
  const [fileName, setFileName] = useState("");
  const [uploadErr, setUploadErr] = useState("");
  const fileRef = useRef(null);
  const [courses, setCourses] = useState([]);
  const [courseParts, setCourseParts] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState(null);
  const [selectedCourseTitle, setSelectedCourseTitle] = useState("");
  const [selectedParts, setSelectedParts] = useState({});
  const [totalAmount, setTotalAmount] = useState(0);
  const [noScreenshotReason, setNoScreenshotReason] = useState("");
  const [cantUploadScreenshot, setCantUploadScreenshot] = useState(false);
  const [notPaid, setNotPaid] = useState(false);
  const API = "https://newwayit.com/adminbackend";

  useEffect(() => {
    fetch(`${API}/fetchcourses.php`)
      .then((r) => r.json())
      .then((d) => setCourses(d.courses || []));
  }, []);

  const handleSelectCourse = async (course) => {
    if (selectedCourseId === course.id) {
      setSelectedCourseId(null);
      setSelectedCourseTitle("");
      setCourseParts([]);
      setSelectedParts({});
      return;
    }

    setSelectedCourseId(course.id);
    setSelectedCourseTitle(course.title);

    const res = await fetch(`${API}/fetchcourseparts.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ course_id: course.id }),
    });

    const data = await res.json();

    const parts = data.parts || [];

    setCourseParts(parts);

    const selected = {};
    parts.forEach((p) => {
      selected[p.id] = p;
    });

    setSelectedParts(selected);
  };

  const togglePart = (part) => {
    setSelectedParts((prev) => {
      const copy = { ...prev };
      if (copy[part.id]) {
        delete copy[part.id];
      } else {
        copy[part.id] = part;
      }
      return copy;
    });
  };

  useEffect(() => {
    const sum = Object.values(selectedParts).reduce(
      (acc, p) => acc + Number(p.price),
      0,
    );
    setTotalAmount(sum);
  }, [selectedParts]);

  const submitRegistration = async () => {
    const modules = Object.values(selectedParts);

    const res = await fetch(`${API}/registration/saveRegistration.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        firstName: form.firstName,
        lastName: form.lastName,
        email: form.email,
        mobile: form.mobile,

        course_id: selectedCourseId,
        course_title: selectedCourseTitle,

        total_amount: totalAmount,

        modules: modules,
        cant_upload_screenshot: noScreenshotReason === "technical" ? 1 : 0,
        not_paid: noScreenshotReason === "notpaid" ? 1 : 0,
      }),
    });

    const data = await res.json();

    return data;
  };

  const uploadPayment = async (registration_id) => {
    const fd = new FormData();

    fd.append("registration_id", registration_id);
    fd.append("file", screenshot);

    await fetch(`${API}/registration/uploadPayment.php`, {
      method: "POST",
      body: fd,
    });
  };

  const handleFinalSubmit = async () => {
    try {
      const data = await submitRegistration();

      if (data.status) {
        if (screenshot) {
          await uploadPayment(data.registration_id);
        }

        setStep(9);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const validate = () => {
    const e = {};
    if (!form.firstName.trim()) e.firstName = "Required";
    if (!form.lastName.trim()) e.lastName = "Required";
    if (!form.email.trim()) e.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
      e.email = "Invalid email";
    if (!form.mobile.trim()) e.mobile = "Required";
    else if (!/^\d{10}$/.test(form.mobile)) e.mobile = "Must be 10 digits";
    if (!form.terms) e.terms = "Please agree to the Terms";
    return e;
  };

  const handleSubmit = () => {
    const e = validate();
    setErrors(e);
    if (!Object.keys(e).length) setStep(6);
  };
  const handleFile = (ev) => {
    const f = ev.target.files[0];
    if (!f) return;
    if (!["image/png", "image/jpeg", "image/jpg"].includes(f.type)) {
      setUploadErr("PNG / JPG / JPEG only");
      return;
    }
    setUploadErr("");
    setScreenshot(f);
    setFileName(f.name);
    setNoScreenshotReason("");
  };
  const handlePay = () => {
    if (!screenshot && !noScreenshotReason) {
      setUploadErr("Please upload screenshot or select a reason.");
      return;
    }

    setUploadErr("");
    setStep(9);
  };
  const reset = () => {
    setStep(1);
    setForm({
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      terms: false,
    });
    setScreenshot(null);
    setFileName("");
    setErrors({});
    setUploadErr("");
  };
  const sc = (n) => (n < step ? "done" : n === step ? "active" : "");

  return (
    <>
      <style>{styles}</style>
      <div className="page-root">
        {/* HEADER */}
        <div className="brand-header">
          <img src={Logo} className="brand-logo-img" alt="Logo" />
          <div className="brand-text-col">
            <span className="brand-name">NEW WAY IT</span>
            <span className="brand-tagline">Presents</span>
          </div>
          <div className="header-divider" />
          <div className="event-col">
            <div className="event-title">
              Future AI & Software Engineers
              <br />
              Scholarship Olympiad
            </div>
            <div className="event-year">2026 · Official Registration</div>
          </div>
        </div>

        <div className="main-layout">
          <div className="form-side">
            {/* STEP BAR */}
            <div className="steps-bar">
              {[
                ["Intro", 1],
                ["About", 2],
                ["Exam", 3],
                ["Career", 4],
                ["Details", 5],
                ["Program", 6],
                ["Payment", 7],
                ["Proof", 8],
                ["Done", 9],
              ].map(([lbl, n], i) => (
                <div key={n} className="step-block">
                  <div className={`step-circle ${sc(n)}`}>
                    {step > n ? Ico.check : n}
                  </div>

                  <span className={`step-label ${sc(n)}`}>{lbl}</span>

                  {i < 8 && (
                    <div className={`step-conn ${step > n ? "done" : ""}`} />
                  )}
                </div>
              ))}
            </div>

            {/* ══ STEP 1 — HERO ══ */}
            {step === 1 && (
              <div className="hero-wrap">
                <div className="hero-blob hero-blob-1" />
                <div className="hero-blob hero-blob-2" />
                <div className="hero-inner">
                  {/* badges */}
                  <div className="hero-badge-row">
                    <div className="hero-badge">
                      <div className="hero-badge-dot" /> NEW WAY IT
                    </div>
                    <div className="hero-year-tag">🏆 2026 Edition</div>
                  </div>

                  {/* headline */}
                  <div className="hero-title-block">
                    <h1 className="hero-title-lg">
                      AI & Software
                      <br />
                      <em>Scholarship</em> Olympiad
                    </h1>
                    <p className="hero-subtitle">
                      India's most ambitious scholarship program for the next
                      generation of software engineers and AI innovators.
                    </p>
                  </div>

                  <div className="hero-content-grid">
                    <div className="hero-left">
                      {/* stats */}
                      <div className="hero-stats">
                        <div className="hero-stat">
                          <div className="hero-stat-val">
                            20<span>+</span>
                          </div>
                          <div className="hero-stat-lbl">Scholarships</div>
                        </div>
                        <div className="hero-stat">
                          <div className="hero-stat-val">
                            100<span>%</span>
                          </div>
                          <div className="hero-stat-lbl">Top Prize</div>
                        </div>
                        <div className="hero-stat">
                          <div className="hero-stat-val">
                            1<span>yr</span>
                          </div>
                          <div className="hero-stat-lbl">Roadmap</div>
                        </div>
                      </div>

                      {/* tracks */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "8px",
                        }}
                      >
                        {[
                          ["💻", "Software Development"],
                          ["🤖", "Artificial Intelligence"],
                          ["🌐", "Full Stack Web"],
                          ["🎓", "Class 8 → Postgrad"],
                        ].map(([ico, lbl]) => (
                          <div key={lbl} className="sch-track">
                            <span className="sch-track-ico">{ico}</span>
                            <span>{lbl}</span>
                          </div>
                        ))}
                      </div>

                      {/* CTA */}
                      <div className="hero-cta-row">
                        <button
                          className="hero-cta-btn"
                          onClick={() => setStep(2)}
                        >
                          Start Registration {Ico.arrow}
                        </button>
                        <div className="hero-fee-note">
                          Registration Fee: <strong>₹500</strong>
                        </div>
                      </div>
                    </div>

                    {/* scholarship card */}
                    <div className="sch-card">
                      <div className="sch-card-head">
                        <div className="sch-card-title">
                          Scholarships Available
                        </div>
                        <div className="sch-trophy">🏆</div>
                      </div>
                      <div className="sch-tiers">
                        {[
                          {
                            pct: "100%",
                            grade: "gold",
                            label: "Gold Merit",
                            count: "Top 5 students",
                            badge: "FULL",
                          },
                          {
                            pct: "50%",
                            grade: "silver",
                            label: "Silver Merit",
                            count: "Next 5 students",
                            badge: "HALF",
                          },
                          {
                            pct: "30%",
                            grade: "bronze",
                            label: "Bronze Merit",
                            count: "Next 5 students",
                            badge: "30%",
                          },
                          {
                            pct: "25%",
                            grade: "extra",
                            label: "Recognition",
                            count: "Next 5 students",
                            badge: "25%",
                          },
                        ].map((t) => (
                          <div key={t.pct} className="sch-tier-row">
                            <span className={`sch-pct ${t.grade}`}>
                              {t.pct}
                            </span>
                            <div className="sch-tier-info">
                              <div className="sch-tier-label">{t.label}</div>
                              <div className="sch-tier-count">{t.count}</div>
                            </div>
                            <span className={`sch-tier-badge ${t.grade}`}>
                              {t.badge}
                            </span>
                          </div>
                        ))}
                      </div>
                      <div className="sch-divider" />
                      <div
                        style={{
                          fontSize: "10px",
                          color: T.muted,
                          textAlign: "center",
                        }}
                      >
                        Limited seats — merit-based selection
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ══ STEP 2 — ABOUT ══ */}
            {step === 2 && (
              <div className="about-wrap">
                <div className="about-inner">
                  <div className="about-kicker">About the Olympiad</div>
                  <h2 className="about-headline">
                    Real <em>Skills.</em>
                    <br />
                    Not Just Degrees.
                  </h2>
                  <p className="about-lead">
                    At <strong style={{ color: "white" }}>NEW WAY IT</strong>,
                    we believe the future belongs to those who can build. This
                    Olympiad identifies talent and transforms it through
                    world-class technical training.
                  </p>

                  {/* three pillars */}
                  <div className="about-pillars">
                    {[
                      {
                        ico: "🎯",
                        title: "Identify Talent",
                        body: "Discover students with exceptional logical reasoning and technical aptitude through a structured assessment.",
                      },
                      {
                        ico: "💻",
                        title: "Industry Skills",
                        body: "Train selected students with real-world software technologies used by top tech companies globally.",
                      },
                      {
                        ico: "🌎",
                        title: "Global Careers",
                        body: "Open doors to international technology companies and high-income career paths in AI and software.",
                      },
                    ].map((p) => (
                      <div key={p.title} className="about-pillar">
                        <div className="pillar-ico">{p.ico}</div>
                        <div className="pillar-title">{p.title}</div>
                        <div className="pillar-body">{p.body}</div>
                      </div>
                    ))}
                  </div>

                  {/* why row */}
                  <div className="about-why">
                    <div className="about-why-text">
                      <div className="about-why-label">Why This Olympiad?</div>
                      <div className="about-why-body">
                        Today's top companies hire{" "}
                        <strong>skills — not just degrees.</strong> Prove what
                        you can do.
                      </div>
                    </div>
                    <div className="company-chips">
                      {["Microsoft", "Apple", "Infosys", "Global Tech"].map(
                        (c) => (
                          <span key={c} className="company-chip">
                            {c}
                          </span>
                        ),
                      )}
                    </div>
                  </div>

                  {/* eligibility */}
                  <div className="about-elig-row">
                    <div className="elig-card">
                      <div className="elig-head">
                        <div className="elig-head-ico">👨‍🎓</div>
                        <div>
                          <div className="elig-head-title">Group A</div>
                          <div className="elig-head-sub">School Students</div>
                        </div>
                      </div>
                      <div className="elig-list">
                        {[
                          "Class 8th",
                          "Class 9th",
                          "Class 10th",
                          "Class 11th",
                          "Class 12th",
                        ].map((c) => (
                          <div key={c} className="elig-item">
                            <div className="elig-dot" />
                            <span>{c}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="elig-card">
                      <div className="elig-head">
                        <div className="elig-head-ico">🎓</div>
                        <div>
                          <div className="elig-head-title">Group B</div>
                          <div className="elig-head-sub">
                            College Students — Any Stream
                          </div>
                        </div>
                      </div>
                      <div className="elig-list">
                        {[
                          "BA, B.Com, BBA",
                          "BCA, B.Sc, B.Tech",
                          "MA, M.Com, MBA",
                          "MCA, M.Tech",
                        ].map((c) => (
                          <div key={c} className="elig-item">
                            <div className="elig-dot" />
                            <span>{c}</span>
                          </div>
                        ))}
                      </div>
                      <div className="elig-no-code">
                        ✅ No coding experience required
                      </div>
                    </div>
                  </div>

                  <div className="step-actions">
                    <button className="btn-back" onClick={() => setStep(1)}>
                      ← Back
                    </button>
                    <button
                      className="btn-pri"
                      style={{ maxWidth: "200px" }}
                      onClick={() => setStep(3)}
                    >
                      Continue →
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ══ STEP 3 — EXAM ══ */}
            {step === 3 && (
              <div className="exam-wrap">
                <div className="exam-inner">
                  <div className="exam-kicker">Exam & Learning Path</div>
                  <h2 className="exam-headline">
                    What to <em>Expect</em>
                    <br />& What You'll Learn
                  </h2>
                  <p className="exam-lead">
                    A structured assessment followed by a comprehensive 1-year
                    developer training roadmap.
                  </p>

                  <div className="exam-grid">
                    {/* left: exam pattern */}
                    <div className="exam-meta-col">
                      <div className="exam-stat-row">
                        <div className="exam-stat-box">
                          <div className="exam-stat-icon">⏱</div>
                          <div className="exam-stat-val">60</div>
                          <div className="exam-stat-lbl">Minutes</div>
                        </div>
                        <div className="exam-stat-box">
                          <div className="exam-stat-icon">📊</div>
                          <div className="exam-stat-val">50</div>
                          <div className="exam-stat-lbl">Questions</div>
                        </div>
                      </div>
                      <div className="exam-sections-box">
                        <div className="exam-sections-title">Exam Sections</div>
                        {[
                          "Logical Reasoning",
                          "Basic Mathematics",
                          "Computer Awareness",
                          "Technology Aptitude",
                          "Problem Solving",
                        ].map((s, i) => (
                          <div key={s} className="exam-section-item">
                            <div className="exam-section-num">{i + 1}</div>
                            <div className="exam-section-name">{s}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* right: skills */}
                    <div className="exam-skills-col">
                      <div className="exam-skills-title">
                        What You Will Learn
                      </div>
                      <div className="exam-skills-grid">
                        {[
                          {
                            ico: "💻",
                            name: "Frontend Development",
                            tags: ["HTML", "CSS", "React", "Next.js"],
                          },
                          {
                            ico: "⚙️",
                            name: "Full Stack Development",
                            tags: ["Node.js", "APIs", "Databases"],
                          },
                          {
                            ico: "🧠",
                            name: "Programming Languages",
                            tags: ["Python", "Java", "C/C++", "JS"],
                          },
                          {
                            ico: "🤖",
                            name: "AI Fundamentals",
                            tags: ["ML Basics", "Data", "Automation"],
                          },
                        ].map((s) => (
                          <div key={s.name} className="skill-row">
                            <div className="skill-ico-box">{s.ico}</div>
                            <div>
                              <div className="skill-name">{s.name}</div>
                              <div className="skill-tags">
                                {s.tags.map((t) => (
                                  <span key={t} className="skill-tag">
                                    {t}
                                  </span>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* roadmap timeline */}
                  <div className="roadmap-section">
                    <div className="roadmap-title">1-Year Career Roadmap</div>
                    <div className="roadmap-timeline">
                      {[
                        "Programming\nBasics",
                        "Web\nDevelopment",
                        "JavaScript\n& React",
                        "Backend\nDev",
                        "AI\nBasics",
                        "Industry\nProjects",
                      ].map((label, i) => (
                        <div key={i} className="roadmap-step">
                          <div className="roadmap-node">{i + 1}</div>
                          <div className="roadmap-text">{label}</div>
                        </div>
                      ))}
                    </div>
                    <div className="roadmap-end-note">
                      🎯 Beginner → Professional Developer in 12 months
                    </div>
                  </div>

                  <div className="step-actions">
                    <button className="btn-back" onClick={() => setStep(2)}>
                      ← Back
                    </button>
                    <button
                      className="btn-pri"
                      style={{ maxWidth: "200px" }}
                      onClick={() => setStep(4)}
                    >
                      Continue →
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ══ STEP 4 — CAREER ══ */}
            {step === 4 && (
              <div className="career-wrap">
                <div className="career-inner">
                  <div className="career-kicker">Career Opportunities</div>
                  <h2 className="career-headline">
                    Your Future <em>Starts</em>
                    <br />
                    After This Program
                  </h2>
                  <p className="career-lead">
                    Completing the program opens doors to high-income global
                    tech careers — with real skills, real projects, and real
                    recognition.
                  </p>

                  <div className="career-two-col">
                    {/* roles */}
                    <div>
                      <div
                        style={{
                          fontSize: "10px",
                          textTransform: "uppercase",
                          letterSpacing: "0.15em",
                          color: T.gold,
                          fontWeight: 600,
                          marginBottom: "12px",
                        }}
                      >
                        Career Roles
                      </div>
                      <div className="career-roles-grid">
                        {[
                          { ico: "💻", name: "Software Developer" },
                          { ico: "⚙️", name: "Full Stack Developer" },
                          { ico: "🌐", name: "Web Developer" },
                          { ico: "🤖", name: "AI Engineer" },
                          { ico: "🚀", name: "Freelance Developer" },
                        ].map((r) => (
                          <div key={r.name} className="career-role-card">
                            <div className="role-ico">{r.ico}</div>
                            <div className="role-name">{r.name}</div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* certs */}
                    <div className="career-certs-col">
                      <div className="career-certs-title">
                        Certificates & Recognition
                      </div>
                      {[
                        {
                          ico: "📜",
                          name: "Participation Certificate",
                          detail: "All registered students",
                        },
                        {
                          ico: "🏆",
                          name: "Excellence Certificate",
                          detail: "Top 100 performers",
                        },
                        {
                          ico: "🥇",
                          name: "Scholarship Award",
                          detail: "Top 20 — merit-based",
                        },
                      ].map((c) => (
                        <div key={c.name} className="cert-item">
                          <div className="cert-ico">{c.ico}</div>
                          <div>
                            <div className="cert-name">{c.name}</div>
                            <div className="cert-detail">{c.detail}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* opportunity banner */}
                  <div className="opp-banner">
                    <div className="opp-star">⭐</div>
                    <div className="opp-text">
                      <div className="opp-title">Work with NEW WAY IT</div>
                      <div className="opp-body">
                        Top performers may receive an opportunity to work
                        directly with our team on real industry projects.
                      </div>
                    </div>
                  </div>

                  {/* bottom row */}
                  <div className="career-bottom-row">
                    <div className="limited-panel">
                      <h4>⚠️ Limited Opportunity</h4>
                      <p>
                        Only <strong>20 Scholarships</strong> available. Don't
                        miss your chance to build a{" "}
                        <strong>high-income tech career</strong> from an early
                        age.
                      </p>
                    </div>
                    <div className="contact-panel">
                      <h4>📞 Contact Us</h4>
                      <div className="contact-row">
                        <span className="contact-icon">📲</span>
                        <span>
                          Call / WhatsApp: <strong>7717254001</strong>
                        </span>
                      </div>
                      <div className="contact-row">
                        <span className="contact-icon">🌐</span>
                        <span>
                          <strong>www.newwayit.com</strong>
                        </span>
                      </div>
                      <div className="contact-row">
                        <span className="contact-icon">📧</span>
                        <span>
                          <strong>career@newwayit.com</strong>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="step-actions">
                    <button className="btn-back" onClick={() => setStep(3)}>
                      ← Back
                    </button>
                    <button
                      className="btn-pri"
                      style={{ maxWidth: "240px" }}
                      onClick={() => setStep(5)}
                    >
                      Continue Registration →
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ══ STEP 5 — PERSONAL DETAILS ══ */}
            {step === 5 && (
              <div className="card" key="s1">
                <div className="card-eyebrow">Step 1 of 3</div>
                <div className="card-title">Personal Details</div>
                <div className="card-sub">
                  Enter your information exactly as it appears on your ID
                </div>

                <div className="field-full">
                  <span className="flbl">First Name</span>
                  <div className="iwrap">
                    <span className="iico">{Ico.user}</span>
                    <input
                      className={`fi${errors.firstName ? " err" : ""}`}
                      type="text"
                      placeholder="Arjun"
                      value={form.firstName}
                      onChange={(e) =>
                        setForm({ ...form, firstName: e.target.value })
                      }
                    />
                  </div>
                  {errors.firstName && (
                    <span className="emsg">{errors.firstName}</span>
                  )}
                </div>
                <div className="field-full">
                  <span className="flbl">Last Name</span>
                  <div className="iwrap">
                    <span className="iico">{Ico.user}</span>
                    <input
                      className={`fi${errors.lastName ? " err" : ""}`}
                      type="text"
                      placeholder="Sharma"
                      value={form.lastName}
                      onChange={(e) =>
                        setForm({ ...form, lastName: e.target.value })
                      }
                    />
                  </div>
                  {errors.lastName && (
                    <span className="emsg">{errors.lastName}</span>
                  )}
                </div>
                <div className="field-full">
                  <span className="flbl">Email Address</span>
                  <div className="iwrap">
                    <span className="iico">{Ico.mail}</span>
                    <input
                      className={`fi${errors.email ? " err" : ""}`}
                      type="email"
                      placeholder="you@example.com"
                      value={form.email}
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                    />
                  </div>
                  {errors.email && <span className="emsg">{errors.email}</span>}
                </div>
                <div className="field-full">
                  <span className="flbl">Mobile Number</span>
                  <div className="iwrap">
                    <span className="iico">{Ico.phone}</span>
                    <input
                      className={`fi${errors.mobile ? " err" : ""}`}
                      type="tel"
                      maxLength={10}
                      placeholder="10-digit number"
                      value={form.mobile}
                      onChange={(e) =>
                        setForm({
                          ...form,
                          mobile: e.target.value.replace(/\D/g, ""),
                        })
                      }
                    />
                  </div>
                  {errors.mobile && (
                    <span className="emsg">{errors.mobile}</span>
                  )}
                </div>

                <div className="sec-div">
                  <span>Terms</span>
                </div>
                <label className="cb-row">
                  <input
                    type="checkbox"
                    checked={form.terms}
                    onChange={(e) =>
                      setForm({ ...form, terms: e.target.checked })
                    }
                  />
                  <span>
                    I have read and agree to the{" "}
                    <a href="#">Terms &amp; Conditions</a>
                  </span>
                </label>
                {errors.terms && (
                  <div
                    className="emsg"
                    style={{ marginBottom: "8px", marginTop: "-6px" }}
                  >
                    {errors.terms}
                  </div>
                )}
                <button
                  className="btn-pri"
                  style={{ marginBottom: "10px" }}
                  onClick={() => setStep(4)}
                >
                  ← Back
                </button>
                <button className="btn-pri" onClick={handleSubmit}>
                  Continue to Payment {Ico.arrow}
                </button>
              </div>
            )}

            {/* ══ STEP 6 — PROGRAM ══ */}
            {step === 6 && (
              <div className="card">
                <div className="card-eyebrow">Step 2 of 4</div>
                <div className="card-title">Select Program for Scholarship</div>
                <div className="card-sub">Select the course</div>
                <div className="program-layout">
                  <div className="program-box">
                    <h3>Select Course</h3>
                    <button
                      className={`course-btn ${selectedCourseId === "modules" ? "active" : ""}`}
                      onClick={() => {
                        setSelectedCourseId("modules");
                        setSelectedCourseTitle("Individual Modules");

                        setCourseParts(individualModules);
                        setSelectedParts({});
                      }}
                    >
                      Individual Modules
                    </button>
                    {courses.map((c) => (
                      <button
                        key={c.id}
                        className={`course-btn ${Number(selectedCourseId) === Number(c.id) ? "active" : ""}`}
                        onClick={() => handleSelectCourse(c)}
                      >
                        <span>{c.title}</span>
                        <span>₹{c.price}</span>
                      </button>
                    ))}
                  </div>
                  <div className="program-box">
                    <h3>Modules of {selectedCourseTitle || "—"}</h3>

                    {courseParts.map((part) => (
                      <div key={part.id} className="module-card">
                        <label className="module-label">
                          <input
                            type="checkbox"
                            className="module-checkbox"
                            disabled={selectedCourseId !== "modules"}
                            checked={!!selectedParts[part.id]}
                            onChange={() => togglePart(part)}
                          />

                          <span className="checkbox-ui"></span>

                          <div className="module-info">
                            <span className="module-title">
                              {part.part_name}
                            </span>
                            <span className="module-price">₹{part.price}</span>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="total-box">
                  <span>Total Program Cost</span>
                  <span>₹{totalAmount}</span>
                </div>
                <button
                  className="btn-pri program-next"
                  disabled={
                    !selectedCourseId || Object.keys(selectedParts).length === 0
                  }
                  onClick={() => setStep(5)}
                >
                  ← Back
                </button>
                <button
                  className="btn-pri program-next"
                  disabled={
                    !selectedCourseId || Object.keys(selectedParts).length === 0
                  }
                  onClick={() => setStep(7)}
                >
                  Continue to Payment
                </button>
              </div>
            )}

            {/* ══ STEP 7 — PAYMENT ══ */}
            {step === 7 && (
              <div className="card" key="s2">
                <div className="card-eyebrow">Step 7 of 9</div>
                <div className="card-title">Complete Payment</div>
                <div className="card-sub">
                  Hi {form.firstName} — scan the QR code via Google Pay to
                  proceed
                </div>
                <div className="pay-layout">
                  <div className="qr-side">
                    <span className="amt-badge">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#C9A84C"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        width="11"
                        height="11"
                      >
                        <circle cx="12" cy="12" r="10" />
                        <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
                        <path d="M12 6v2m0 8v2" />
                      </svg>
                      ₹500
                    </span>
                    <div className="qr-box">
                      <img
                        src="/images/gpay-qr.jpeg"
                        alt="GPay QR"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextSibling.style.display = "flex";
                        }}
                      />
                      <div className="qr-ph" style={{ display: "none" }}>
                        {Ico.qr}
                        <span>gpay-qr.png</span>
                      </div>
                    </div>
                    <p className="qr-desc">
                      Scan via{" "}
                      <strong style={{ color: "#E8E6F2", fontWeight: "500" }}>
                        Any UPI App
                      </strong>{" "}
                      to complete payment
                    </p>
                  </div>
                </div>
                <button
                  className="btn-pri program-next"
                  onClick={() => setStep(6)}
                >
                  ← Back
                </button>
                <button
                  className="btn-pri program-next"
                  onClick={() => setStep(8)}
                >
                  Submit Registration {Ico.arrow}
                </button>
              </div>
            )}

            {/* ══ STEP 7 — PAYMENT ══ */}
            {step === 8 && (
              <div className="card" key="s2">
                <div className="card-eyebrow">Step 8 of 9</div>
                <div className="card-title">Upload Payment Screenshot</div>

                <div className="pay-layout">
                  <div className="upload-side">
                    <span className="upload-label">Upload Screenshot</span>

                    <div className={`up-area${fileName ? " has-f" : ""}`}>
                      <input
                        type="file"
                        accept=".png,.jpg,.jpeg,.heif"
                        ref={fileRef}
                        onChange={handleFile}
                      />

                      <div className="up-ico">{Ico.upload}</div>

                      <div className="up-txt">
                        <strong>Click to upload</strong>
                      </div>

                      <div className="up-hint">PNG · JPG · JPEG · HEIF</div>

                      {fileName && <div className="f-name">✓ {fileName}</div>}
                    </div>

                    {uploadErr && <div className="emsg">{uploadErr}</div>}
                  </div>
                </div>

                {/* SHOW CHECKBOXES ONLY IF NO SCREENSHOT */}
                {!fileName && (
                  <div style={{ marginTop: "12px" }}>
                    <label className="cb-row">
                      <input
                        type="checkbox"
                        checked={noScreenshotReason === "technical"}
                        onChange={() => {
                          setNoScreenshotReason("technical");
                          setScreenshot(null);
                          setFileName("");
                        }}
                      />
                      <span>
                        Can't upload screenshot due to technical issue
                      </span>
                    </label>

                    <label className="cb-row">
                      <input
                        type="checkbox"
                        checked={noScreenshotReason === "notpaid"}
                        onChange={() => {
                          setNoScreenshotReason("notpaid");
                          setScreenshot(null);
                          setFileName("");
                        }}
                      />
                      <span>Payment not done yet</span>
                    </label>
                  </div>
                )}
                <button
                  className="btn-pri program-next"
                  onClick={() => setStep(7)}
                >
                  Back
                </button>
                <button
                  className="btn-pri program-next"
                  onClick={handleFinalSubmit}
                >
                  Submit Registration
                </button>
              </div>
            )}

            {/* ══ STEP 8 — SUCCESS ══ */}
            {step === 9 && (
              <div className="card" key="s3">
                <div className="succ-layout">
                  <div className="succ-ico">{Ico.checkG}</div>
                  <div className="succ-title">Registration Confirmed</div>
                  <p className="succ-msg">
                    Your registration has been submitted.
                    <br />
                    We'll verify your payment and send confirmation to{" "}
                    <strong>{form.email}</strong>.
                  </p>
                  <div className="info-pill">
                    {Ico.info}
                    <span>
                      Confirmation typically arrives within 24–48 hours. Check
                      your inbox and spam folder.
                    </span>
                  </div>
                  <div className="sum-box">
                    <div className="sum-h">Registration Summary</div>
                    {[
                      ["Candidate", `${form.firstName} ${form.lastName}`],
                      ["Email", form.email],
                      ["Mobile", `+91 ${form.mobile}`],
                      [
                        "Fee",
                        noScreenshotReason === "notpaid"
                          ? "Not Paid Yet"
                          : "₹500 (Pending Verification)",
                      ],
                    ].map(([k, v]) => (
                      <div className="sum-row" key={k}>
                        <span className="sk">{k}</span>
                        <span className="sv">{v}</span>
                      </div>
                    ))}
                  </div>
                  <button
                    className="btn-ghost"
                    style={{ width: "100%" }}
                    onClick={reset}
                  >
                    {Ico.home} Return to Home
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
